import { Box, Button, Heading } from 'grommet'
import styled, { css } from 'styled-components'

import { NormalizedWrapper } from '@theme'

import { SoftPlatformStyles } from './types'

export const Wrapper = styled(Box)`
  ${({ theme }) => css`
    background: ${theme.newColors.lightGray};
    margin-top: ${theme.newSpaces.xl10}px;
    padding: ${theme.newSpaces.xl3}px 0;

    ${theme.below.tablet`    
      margin-top: ${theme.newSpaces.xl2}px;
    `}

    ${theme.below.mobileXL`
      padding: ${theme.newSpaces.md}px 0;
    `}
  `}
`

export const Container = styled(NormalizedWrapper)`
  max-width: 845px;

  ${({ theme }) => css`
    ${theme.below.mobileXL`
      padding: 0 ${theme.newSpaces.xs}px;
    `}
  `}
`

export const Title = styled(Heading)`
  ${({ theme }) => css`
    ${theme.getTypography('desktop', 'title', 'title1')}

    color: ${theme.newColors.primary};

    ${theme.below.mobileXL`
      ${theme.getTypography('mobile', 'title', 'title1')}

      text-align: center;
    `}
  `}
`

export const Form = styled.form`
  ${({ theme }) => css`
    margin-top: ${theme.newSpaces.lg}px;

    input,
    textarea {
      ${theme.getTypography('desktop', 'body', 'body2')}

      background: transparent;
      border: 2px solid ${theme.newColors.accent};
      color: ${theme.newColors.gray};
      height: 50px;
      outline: inherit;
      padding: ${theme.newSpaces.xs2}px ${theme.newSpaces.xs}px;
      width: 100%;
    }

    textarea {
      min-height: 100px;
      resize: none;

      & ~ p {
        margin-top: 0;
      }

      ${({ theme }) => theme.below.tabletS`
        min-height: 170px;
      `}
    }

    p {
      color: ${theme.newColors.errorGrayBG};
      margin-top: ${theme.newSpaces.xs3}px;
    }

    ${theme.below.mobileXL`
      margin-top: ${theme.newSpaces.md}px;
    `}
  `}
`

export const Label = styled.label`
  display: block;

  ${({ theme }) => css`
    ${theme.getTypography('desktop', 'title', 'title2')}

    color: ${theme.newColors.primary};
    margin-bottom: ${theme.newSpaces.xs2}px;
    margin-top: ${theme.newSpaces.lg}px;

    ${theme.below.mobileXL`
      ${theme.getTypography('mobile', 'title', 'title3')}

      text-transform: uppercase;
      margin-top: ${theme.newSpaces.md}px;
    `}
  `}
`

export const Inputs = styled(Box)`
  max-width: 540px;

  ${({ theme }) => theme.below.laptop`
    max-width: 100%;
  `}
`

export const SoftPlatforms = styled(Box)`
  flex-direction: row;
  justify-content: space-between;
  max-width: 100%;
`

export const SoftPlatform = styled(Box)<SoftPlatformStyles>`
  align-items: center;
  background: transparent;
  box-shadow: none;
  cursor: pointer;
  height: 50px;
  justify-content: center;
  width: 174px;

  ${({ theme, active }) => css`
    ${theme.getTypography('desktop', 'button', 'normal')}

    border: 2px solid ${active ? theme.newColors.accent : theme.newColors.gray};
    color: ${active ? theme.newColors.accent : theme.newColors.gray};

    ${theme.below.tabletL`
      width: 32%;
    `}

    ${theme.below.mobileM`
      ${theme.getTypography('mobile', 'button', 'normal')}
    `}
  `}
`

export const HexagonWrapper = styled(Box)`
  & > svg {
    height: 240px;
    width: 235px;

    & > path {
      transform: translateY(10px);
      transition: 0.3s all ease;
    }
  }

  ${({ theme }) => css`
    margin-top: ${theme.newSpaces.lg}px;

    ${({ theme }) => theme.below.tabletL`
      display: none;
    `}
  `}
`

export const SmallHexagonWrapper = styled(Box)`
  display: none;
  flex-direction: row;
  justify-content: center;

  & > svg {
    height: 230px;
    width: 246px;

    & > path {
      transform: translateY(10px);
      transition: 0.3s all ease;
    }
  }

  ${({ theme }) => css`
    margin-bottom: ${theme.newSpaces.md}px;

    ${theme.below.tabletL`
      display: flex;
    `}
  `}
`

export const Content = styled(Box)`
  align-items: center;
  flex-direction: row;
  justify-content: space-between;

  ${({ theme }) => css`
    ${theme.below.tabletL`
      display: block;
    `}
  `}
`

export const SubmitButton = styled(Button)`
  height: 50px;
  text-align: center;
  width: 217px;

  ${({ theme }) => css`
    ${theme.getTypography('desktop', 'button', 'normal')}

    background: ${theme.newColors.primary};
    color: ${theme.newColors.white};
    margin-top: ${theme.newSpaces.lg}px;

    &:hover {
      text-decoration: underline;
      text-decoration-thickness: 2px;
      text-underline-offset: 5px;

      &:disabled {
        text-decoration: none;
      }
    }

    &:disabled {
      opacity: 1;
    }

    ${theme.below.mobileXL`
      ${theme.getTypography('mobile', 'button', 'normal')}

      margin-top: ${theme.newSpaces.md}px;
      width: 100%;
    `}
  `}

  & > div {
    left: 8%;
    position: relative;
  }
`

export const SubmittedText = styled(Heading)`
  text-align: center;
  white-space: pre-wrap;

  ${({ theme }) => css`
    ${theme.getTypography('mobile', 'title', 'blog')}

    color: ${theme.newColors.primary};

    ${theme.below.tabletS`
      ${theme.getTypography('mobile', 'title', 'title1')}

      white-space: normal;
    `}
  `}
`
